import { render, staticRenderFns } from "./FamiliesWithIcon.vue?vue&type=template&id=6334cba9&scoped=true&"
import script from "./FamiliesWithIcon.vue?vue&type=script&lang=js&"
export * from "./FamiliesWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./FamiliesWithIcon.vue?vue&type=style&index=0&id=6334cba9&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334cba9",
  null
  
)

export default component.exports